import ZLinkField from './ZLinkField.js';


export default window.ZForms.registerClass('field.link_list', class ZLinkListField extends ZLinkField {
  async parseRawValue(rawVal) {
    if (rawVal == null) return [];
    return await Promise.all(rawVal.map(async (rawEntity) => await window.ZForms.parseRaw(rawEntity, this.entityForm.contentMeta, this.rootEntity)));
  }

  async parseRawValue(rawVal) {
    const curContainer = new this.entityForm.constructor(this.entityForm.meta, this);
    curContainer.contentMeta = this.entityForm.contentMeta;
    await curContainer.updateFromRaw({
      'content': rawVal == null ? [] : rawVal,
    });

    return curContainer;
  }

  getDefault() {
    const curContainer = new this.entityForm.constructor(this.entityForm.meta, this);
    curContainer.contentMeta = this.entityForm.contentMeta;
    curContainer.updateFromRaw({});
    return curContainer;
  }

  packResponseValue(val) {
    if (val == null) return null;

    return val.content.map((sVal) => sVal.packResponse());
  }
});

